import script from "./user-report.vue?vue&type=script&setup=true&lang=js"
export * from "./user-report.vue?vue&type=script&setup=true&lang=js"

import "./user-report.vue?vue&type=style&index=0&id=ef450d9a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef450d9a"]])

export default __exports__